<script setup>
import { computed } from 'vue'
import { useWebSiteStore } from '@/stores/website.store'

import i18n from '@/plugins/i18n'

const websiteStore = useWebSiteStore()
const t = i18n.global.t

const userFullName = computed(() => {
  const user = websiteStore.userData
  if (!user || !user.first_name || !user.last_name) return t('nav.user')
  return `${user.first_name} ${user.last_name}`
})

const handleLogout = async() => {
  await websiteStore.logoutAsync()
}
</script>

<template>
  <q-list
    dense
    style="min-width: 15rem"
  >
    <q-item>
      <q-item-section>
        <q-item-label class="text-weight-bold">
          {{ userFullName }}
        </q-item-label>
      </q-item-section>
    </q-item>
    <q-separator />
    <q-item
      v-ripple
      clickable
      @click="handleLogout"
    >
      <q-item-section avatar>
        <q-icon name="mdi-logout" />
      </q-item-section>
      <q-item-section>{{ $t('nav.logout') }}</q-item-section>
    </q-item>
  </q-list>
</template>
